function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FYI-Document-Icons",
  transform: "translate(-216.000000, -1139.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Audio",
  transform: "translate(0.000000, 1111.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Main",
  transform: "translate(216.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#1ACB68",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8446595,18.6659161 L10.8446595,18.9673012 L10.8446595,20.8634981 L10.8446595,26.2004415 C10.3610707,25.9091515 9.79434129,25.7382014 9.18566014,25.7382014 C7.42673945,25.7382014 6,27.1402924 6,28.8681635 C6,30.5979089 7.42635807,32 9.18566014,32 C10.9438181,32 12.3697948,30.5982838 12.3701761,28.8689132 L12.3701761,20.4323739 L20.4744834,18.1421669 L20.4744834,23.4986046 C19.9908946,23.2073145 19.4241651,23.0363644 18.815484,23.0363644 C17.0558005,23.0363644 15.6298239,24.4380806 15.6298239,26.1659516 C15.6298239,27.8953222 17.0558005,29.2977881 18.815484,29.2977881 C20.4721951,29.2977881 21.8337187,28.0512767 21.9847448,26.4598659 L22,17.7110426 L22,16.3666847 L22,16.3666847 C22,15.3778198 21.1983666,14.5761863 20.2095016,14.5761863 C20.0448464,14.5761863 19.880978,14.5988985 19.7225296,14.6436808 L12.3007081,16.7413079 C11.4393715,16.9847472 10.8446595,17.7708388 10.8446595,18.6659161 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#57E783",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
}))), /*#__PURE__*/React.createElement("g", {
  id: "volume-97",
  transform: "translate(5.625000, 13.125000)",
  fill: "#637282",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.6091964,0.0825181925 C11.3375893,-0.0496493684 11.0113393,-0.0219495803 10.7678571,0.157703332 L4.55383929,4.74795395 L0.803571431,4.74795395 C0.359196429,4.74795395 0,5.10171982 0,5.53937647 L0,11.8707566 C0,12.3084133 0.359196429,12.6621792 0.803571431,12.6621792 L4.55383929,12.6621792 L10.7678571,17.2524298 C10.9092857,17.357689 11.0796429,17.4107143 11.25,17.4107143 C11.3721429,17.4107143 11.4958929,17.3830145 11.6091964,17.3276149 C11.8816071,17.1930731 12.0535714,16.9192409 12.0535714,16.6192917 L12.0535714,0.79084135 C12.0535714,0.490892213 11.8816071,0.217060021 11.6091964,0.0825181925 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5557574,5.26147959 L13.9449097,4.6875 L12.7232143,5.83545918 L13.334062,6.40943875 C14.6819013,7.67592837 14.6819013,9.73559775 13.334062,11.0012755 L12.7232143,11.5752551 L13.9449097,12.7232143 L14.5557574,12.1492347 C16.5766523,10.2503121 16.5766523,7.16040219 14.5557574,5.26147959 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.858202,2.67857143 L14.7321429,3.77420977 L15.2951724,4.32202894 C17.7790328,6.73878706 17.7790328,10.6719272 15.2951724,13.0886854 L14.7321429,13.6365045 L15.858202,14.7321429 L16.4212316,14.1843237 C19.5262561,11.1631823 19.5262561,6.24753196 16.4212316,3.22561575 L15.858202,2.67857143 Z",
  id: "Shape"
}))));

var SvgAudio = function SvgAudio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audio.298ad930.svg";
export { ForwardRef as ReactComponent };